export default "__VITE_ASSET__2nK0XSsB__"